export default {
  typeJPEG: 'image/jpeg',
  typeJPG: 'image/jpg',
  typePNG: 'image/png',
  typePDF: 'application/pdf',
  typeCSV: 'application/csv',
  imageTypes(type) {
    let imageTypes = [
      this.typeJPEG,
      this.typeJPG,
      this.typePNG
    ]
    return imageTypes
  },
  isImage(type) {
    let imageTypes = this.imageTypes()
    for(let imageType in imageTypes) {
      if (imageTypes[imageType] === type) {
        return true
      }
    }
    return false
  },
  isPDF(type) {
    if (type === this.typePDF) {
      return true
    }
    return false
  },
  isCSV(type) {
    if (type === this.typeCSV) {
      return true
    }
    return false
  },
  ocToKo(oc) {
    if (isNaN(oc)) {
      return 0
    }
    return Math.round(oc / 1000)
  }
}
